/*
 * @Author: lisl27
 * @Date: 2022-01-12 09:49:18
 * @LastEditors: lisl27
 * @LastEditTime: 2022-01-13 11:20:05
 * @Description: file content
 */
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BasesController } from '../bases';

@BindAll()
export class HomeController<T = any> extends BasesController<T> {
  constructor() {
    super();
    this.reset({
      dataKey: 'productId',
      infinite: true,
      pagination: EnumAPI.business_search,
      paginationParams: {
        currentKey: 'pageNo',
        pageSizeKey: 'pageSize',
        response: {
          dataSource: 'records',
          total: 'total',
          valueGetter: this.valueGetter,
        },
      },
    });
  }
  valueGetter(res) {
    const dataSource = lodash.map(lodash.get(res, 'records'), (item) => {
      const status = item.status != 8 ? item.status : item.reviewBeforeStatus;
      return lodash.assign(item, {
        _status: lodash.get(this.statusEnum, status),
      });
    });
    const total = lodash.get(res, 'total');
    return {
      dataSource,
      total,
    };
  }
  /**
   * @des 状态枚举
   */
  statusEnum = {
    '0': '草稿',
    '1': '已提交',
    '2': '跟进中',
    '3': '持续跟进',
    '4': '已关闭',
    '5': '已提交bidding',
    '6': '已生成报价单',
    '7': '已转订单',
  };

  /**
   * @des 复制商机
   */
  async onBusinessCopyBus(body) {
    return await AjaxBasics.request({
      ...EnumAPI.business_copyBus,
      body,
    });
  }
}
